<template>
  <section class="px-4 py-12 md:py-16">
    <div class="max-w-3xl mx-auto w-full">
      <h2 class="text-center">{{ t('landing.faq.title') }}</h2>

      <div class="mt-4">
        <details
          v-for="item in ITEMS"
          :key="item"
          class="group border-b border-neutral-700 py-4"
        >
          <summary
            class="cursor-pointer font-extrabold flex flex-row justify-between items-center gap-4 list-none [&::-webkit-details-marker]:hidden"
          >
            {{ t(`landing.faq.${item}.question`) }}
            <VaIcon
              name="expand_more"
              class="flex-shrink-0 transition-transform duration-200 group-open:rotate-180"
            />
          </summary>
          <p class="text-neutral-300 mb-0">{{ t(`landing.faq.${item}.answer`) }}</p>
        </details>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { VaIcon } from 'vuestic-ui'

const { t } = useI18n()

const ITEMS = ['price', 'exclusivity', 'ads', 'rights', 'wrongFeed', 'optOut', 'allEpisodes'] as const
</script>
